import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { useCombobox } from 'downshift';
export var autocompleteStrategy = function autocompleteStrategy(state, actionAndChanges) {
  var changes = actionAndChanges.changes,
      type = actionAndChanges.type;

  switch (type) {
    case useCombobox.stateChangeTypes.InputKeyDownEnter:
    case useCombobox.stateChangeTypes.ItemClick:
      return _objectSpread(_objectSpread({}, changes), {}, {
        isOpen: false
      });

    case useCombobox.stateChangeTypes.InputBlur:
      return _objectSpread({}, changes);

    default:
      return changes;
  }
};
export var multiSelectStrategy = function multiSelectStrategy(state, actionAndChanges) {
  var changes = actionAndChanges.changes,
      type = actionAndChanges.type;

  switch (type) {
    case useCombobox.stateChangeTypes.InputKeyDownEnter:
    case useCombobox.stateChangeTypes.ItemClick:
      return _objectSpread(_objectSpread({}, changes), {}, {
        isOpen: true,
        // keep menu open after selection.
        highlightedIndex: state.highlightedIndex,
        inputValue: '' // don't add the item string as input value at selection.

      });

    case useCombobox.stateChangeTypes.InputBlur:
      return _objectSpread(_objectSpread({}, changes), {}, {
        inputValue: '' // don't add the item string as input value at selection.

      });

    default:
      return changes;
  }
};
export var singleSelectStrategy = function singleSelectStrategy(state, actionAndChanges) {
  var changes = actionAndChanges.changes,
      type = actionAndChanges.type;

  switch (type) {
    case useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem:
    case useCombobox.stateChangeTypes.InputKeyDownEnter:
    case useCombobox.stateChangeTypes.ItemClick:
      return _objectSpread(_objectSpread({}, changes), {}, {
        inputValue: ''
      });

    case useCombobox.stateChangeTypes.InputBlur:
      return _objectSpread(_objectSpread({}, changes), {}, {
        inputValue: '' // don't add the item string as input value at selection.

      });

    default:
      return changes;
  }
};